import type { CSSProperties } from 'react';

const draggableStyles: CSSProperties = {
  // Enable hardware acceleration
  willChange: 'transform',
  // Ensure smooth animation with no transition delay
  transitionProperty: 'none',
  // Prevent unnecessary repaints
  backfaceVisibility: 'hidden' as const,
  // Prevent text selection during drag
  userSelect: 'none' as const,
};

export { draggableStyles };
